// Chakra imports
import { Flex } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import Deals from "./components/Deals";
import Projects from "./components/Projects";
import { tablesTableData, dashboardTableData } from "variables/general";
import { useLocalStorage } from "../../../useLocalStorage";
import routes from "../../../routes";
import moment from "moment";
import { upperFirst, sortBy, orderBy } from "lodash";
import { useHistory, useParams } from "react-router-dom";
import DateRender from "common/CellComponents/DateRender";
import AgentsRenderer from "common/CellComponents/AgentsRenderer";
import LockRenderer from "common/CellComponents/LockRenderer";
function Tables({ location }) {
  const navigate = useHistory();
  console.log({ location });
  const { id } = useParams();

  const path = location.pathname.split("/");
  const type = path[path.length - 1];
  const [auth, setAuth] = useLocalStorage("auth_v2", null);
  const [leads, setLeads] = useState(null);
  const [status, setStatus] = useState(true);
  const [allAgents, setAllAgents] = useState([]);
  const [messages, setMessages] = useState([]);
  const [deals, setDeals] = useState([]);
  const [deal, setDeal] = useState(null);
  console.log({ deal });
  const [agentFilter, setAgentFilter] = useState(null);
  const getLeads = async () => {};
  console.log({ id });
  const reSet = () => {
    setDeal(null);
  };
  const reLoad = async (id) => {
    if (auth) {
      console.log("get agents");
      fetch("/api/agents", { headers: { dwelly_token: auth.token } }).then(
        async (messages) => {
          setAllAgents((await messages.json()).agents);
        }
      );
      if (id) {
        console.log("get deal");
        fetch("/api/deals/" + id, {
          headers: { dwelly_token: auth.token },
        }).then(async (messages) => {
          const deal = await messages.json();
          console.log("test 1", { deal });
          if (deal && !deal.deal_id && deals && deals.length > 0) {
            const maxId = deals.reduce(
              (max, item) =>
                parseInt(item.deal_id) > max ? parseInt(item.deal_id) : max,
              0
            );
            deal.deal_id = maxId + 1;
          }
          setDeal(deal);
        });
      } else {
        console.log("get deals");
        fetch("/api/deals", { headers: { dwelly_token: auth.token } }).then(
          async (messages) => {
            setDeals(await messages.json());
          }
        );
      }
    }
  };
  useEffect(() => {
    if (auth && id) reLoad(id);
    else if (!id) setDeal(null);
  }, [auth && id]);
  useEffect(() => {
    if (auth) reLoad();
  }, [auth]);
  console.log({ deals, allAgents, id, deal });
  const rowOnClick = (row_data) => {
    navigate.push("/admin/deals/" + row_data._id);
    /*if (group !== "pending") {
      setRowData(row_data);
      if (group !== "newmuslim") {
        if (group === "volunteer" && !row_data.pin) {
          const maxPin = data.reduce(
            (max, item) => (parseInt(item.pin) > max ? parseInt(item.pin) : max),
            0
          );
          row_data.pin = maxPin + 1;
        }
        editRowData(row_data);
      }
    }*/
  };
  const columnsData1 = [
    {
      Header: "Lock",
      accessor: "locked",
      Cell: LockRenderer,
    },
    {
      Header: "MLS",
      accessor: "MLS",
    },
    {
      Header: "Deal Id",
      accessor: "deal_id",
    },
    {
      Header: "Address",
      accessor: "address",
    },
    {
      Header: "Closing Date",
      accessor: "closing_date",
      Cell: DateRender,
    },
    {
      Header: "Type",
      accessor: "deal_type",
    },
    {
      Header: "Agents",
      accessor: "agents",
      Cell: AgentsRenderer,
    },
  ];
  return (
    <Flex direction="column" pt={{ base: "120px", md: "75px", sm: "50px" }}>
      {auth && deals && allAgents && ((id && deal) || !id) ? (
        <Deals
          rowOnClick={rowOnClick}
          allAgents={allAgents}
          dealId={id}
          deal={deal}
          reLoad={reLoad}
          reSet={reSet}
          status={status}
          setStatus={setStatus}
          title={"Deals"}
          captions={[
            "locked",
            "MLS",
            "deal_id",
            "closing_date",
            "address",
            "deal_type",
            "agents",
            "",
          ]}
          columnsData={columnsData1}
          data={deals}
          auth={auth}
        />
      ) : (
        <>waiting</>
      )}
    </Flex>
  );
}

export default Tables;
